import { testingDetailUrl, testingFinishedPostEditUrl, testingsHomeUrl } from 'mk2/apps/testings/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'testings',
    exact: true,
    path: testingFinishedPostEditUrl,
    getPage: () => {
        return import('mk2/apps/testings/containers/TestingFinishedPostEdit/TestingFinishedPostEditPage' /* webpackChunkName: "testings.TestingFinishedPostEdit" */);
    },
    modules: [ 'mk2/apps/testings/containers/TestingFinishedPostEdit/TestingFinishedPostEditPage' ],
}, {
    app: 'testings',
    exact: true,
    path: testingDetailUrl,
    getPage: () => {
        return import('mk2/apps/testings/containers/TestingDetail/TestingDetailPage' /* webpackChunkName: "testings.TestingDetail" */);
    },
    modules: [ 'mk2/apps/testings/containers/TestingDetail/TestingDetailPage' ],
}, {
    app: 'testings',
    exact: true,
    path: testingsHomeUrl,
    getPage: () => {
        return import('mk2/apps/testings/containers/TestingsHome/TestingsHomePage' /* webpackChunkName: "testings.TestingsHome" */);
    },
    modules: [ 'mk2/apps/testings/containers/TestingsHome/TestingsHomePage' ],
}];
